
import { Component, Vue } from 'vue-property-decorator'
import container from '@/components/moyo/container.vue'
import heading from '@/components/moyo/heading.vue'

@Component({
  name: 'Volunteering',
  components: { container, heading },
})
export default class Volunteering extends Vue {}
